import React from 'react';
import { AlertType, Button, Input } from '@quyva/shared-ui';
import {
    faClose,
    faCopy,
    faInfoCircle,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const FeatureEnabledView = ({
    botName,
    groupName,
    groupUrl,
    setShowTelegramForm,
    repository,
    onRefreshVirtualRepos,
}) => {
    const copyToClipboard = (value) => {
        navigator.clipboard
            .writeText(value)
            .then(() => {
                alert(AlertType.SUCCESS, `Copied to clipboard`);
            })
            .catch((err) => {
                alert(AlertType.ERROR, 'Failed to copy text');
            });
    };

    return (
        <div className='w-full h-full flex flex-col'>
            <div className='flex items-center mb-6'>
                <div className='w-1/2 font-semibold text-texts-secondary300'>
                    <label htmlFor='botName'>Bot Name</label>
                </div>

                <div className='w-full flex items-center'>
                    <div className='relative w-full'>
                        <Input type={'text'} value={botName} disabled={true} />
                    </div>
                    <div className='flex items-center'>
                        <Button
                            className={`ml-2`}
                            hoverText={'Copy bot name'}
                            text={null}
                            icon={faCopy}
                            type={'success'}
                            onClick={() => copyToClipboard(botName)}
                        />
                    </div>
                </div>
            </div>

            {groupName && (
                <div className='flex items-center mb-6'>
                    <div className='w-1/2 font-semibold text-texts-secondary300'>
                        <label htmlFor='botName'>Group Name</label>
                    </div>

                    <div className='w-full flex items-center'>
                        <div className='relative w-full'>
                            <Input
                                type={'text'}
                                value={groupName}
                                disabled={true}
                            />
                        </div>
                        <div className='flex items-center'>
                            <Button
                                className={`ml-2`}
                                hoverText={'Copy group name'}
                                text={null}
                                icon={faCopy}
                                type={'success'}
                                onClick={() => copyToClipboard(groupName)}
                            />
                        </div>
                    </div>
                </div>
            )}

            {groupUrl && (
                <div className='flex items-center mb-6'>
                    <div className='w-1/2 font-semibold text-texts-secondary300'>
                        <label htmlFor='botName'>Group URL</label>
                    </div>

                    <div className='w-full flex items-center'>
                        <div className='relative w-full'>
                            <Input
                                type={'text'}
                                value={groupUrl}
                                disabled={true}
                            />
                        </div>
                        <div className='flex items-center'>
                            <Button
                                className={`ml-2`}
                                hoverText={'Copy Group URL'}
                                text={null}
                                icon={faCopy}
                                type={'success'}
                                onClick={() => copyToClipboard(groupUrl)}
                            />
                        </div>
                    </div>
                </div>
            )}

            <div className='w-full flex-col items-center text-sm mb-8'>
                <div className='flex w-full items-center mb-2'>
                    <FontAwesomeIcon
                        icon={faInfoCircle}
                        className='mr-2 text-texts-tertiary400'
                        title='Information'
                    />
                    <span>
                        Telegram bot has been enabled on your
                        <span className='mx-1 font-semibold'>
                            {repository.name}
                        </span>
                        repository, please use bot name to mention in group to
                        ask questions related to repository. Example:
                        <span className='mx-1 font-semibold'>@{botName}</span>
                    </span>
                </div>
                <div className='flex w-full items-center'>
                    <FontAwesomeIcon
                        icon={faInfoCircle}
                        className='mr-2 text-texts-tertiary400'
                        title='Information'
                    />
                    <span>
                        You can also chat with the bot by directly searching
                        <span className='mx-1 font-semibold'>{botName}</span>
                        in telegram.
                    </span>
                </div>
            </div>

            <div className='w-full flex justify-end items-center'>
                <Button
                    text={'Close'}
                    icon={faClose}
                    type={'danger'}
                    hoverText={'Cancel Telegram Integration'}
                    onClick={() => {
                        setShowTelegramForm(false);
                        
                        if (onRefreshVirtualRepos) {
                            onRefreshVirtualRepos();
                        }
                    }}
                />
            </div>
        </div>
    );
};
